import React, { useRef, useState, useEffect } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    Stack
} from "@mui/material";
import authService from "../../Auth/AuthService";

const SelfieCamera = ({ emp, onSuccess }) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [photo, setPhoto] = useState(null);
    const [seelectedPhoto, setSelectedPhoto] = useState(null);
    const [stream, setStream] = useState(null);
    const token = authService.tokenInfo();
    // const [filePath, setFilePath] = useState(null);

    useEffect(() => {
        startCamera();
        return () => stopCamera();
    }, []);

    useEffect(() => {
        if (videoRef.current && stream) {
            videoRef.current.srcObject = stream;
        }
    }, [stream]);

    const startCamera = async () => {
        try {
            const mediaStream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "user" }
            });

            videoRef.current.srcObject = mediaStream;
            setStream(mediaStream);
        } catch (err) {
            console.error("Camera error:", err);
        }
    };

    const stopCamera = () => {
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }
    };

    const takePhoto = () => {
        const video = videoRef.current;
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(async (blob) => {
            const timestamp = new Date().getTime();
            const customFileName = (`selfie_${emp.id}_${emp.employeeCode}.jpg`).toLowerCase();

            const customFile = new File([blob], customFileName, {
                type: 'image/jpeg',
                lastModified: timestamp
            });

            console.log('Renamed file:', customFile.name); // selfie_123_1634567890123.jpg
            setSelectedPhoto(customFile);

        }, 'image/jpeg', 0.9);

        const preview = canvas.toDataURL("image/jpeg", 0.8);
        setPhoto(preview);
    };

    const handleSave = async () => {
        stopCamera();
        if (!seelectedPhoto) {
            console.error("photo creation failed");
            return;
        }
        console.log("FormData :", emp);
        const formData = new FormData();
        formData.append("file", seelectedPhoto);
        formData.append('dir', token?.mas_id + "/EMP/" + emp.id);
        console.log("FormData file:", formData.get("dir")); // ✅ should not be null

        try {
            const url = authService.pathUrl('POST', '/files/upload')
            const res = await authService.restPostFormData(url, formData)
            // setFilePath(res);
            console.log('Upload success:', res)
            if (onSuccess) onSuccess(res);
        } catch (err) { console.error('Upload error:', err) };

    };

    return (
        <Card sx={{ maxWidth: 500, mx: "auto", mt: 4, p: 2 }}>
            <CardContent>
                <Stack spacing={2} alignItems="center">
                    <Typography variant="h5" fontWeight="bold">
                        Capture Selfie
                    </Typography>

                    <Box
                        sx={{
                            width: "100%",
                            borderRadius: 2,
                            overflow: "hidden",
                            border: "2px solid #ccc"
                        }}
                    >
                        <video
                            ref={videoRef}
                            autoPlay
                            playsInline
                            style={{ width: "100%" }}
                        />
                    </Box>

                    <Button
                        variant="contained"
                        size="large"
                        onClick={takePhoto}
                    >
                        Take Selfie
                    </Button>

                    <canvas ref={canvasRef} style={{ display: "none" }} />

                    {photo && (
                        <>
                            <Typography variant="h6">Preview</Typography>
                            <Box
                                component="img"
                                src={photo}
                                alt="Selfie"
                                sx={{
                                    width: "100%",
                                    borderRadius: 2,
                                    border: "2px solid #4caf50"
                                }}
                            />

                            <Button
                                variant="contained"
                                size="large"
                                onClick={handleSave}
                            >
                                upload
                            </Button>
                        </>
                    )}
                </Stack>
            </CardContent>
        </Card>
    );
};

export default SelfieCamera;